import Footer from '@/components/common/Footer';
import Sidebar from '@/components/common/Sidebar';
import BottomNav from '@/components/BottomNav';
import Header from '@/components/Header';
import { StickySportStrip } from '@/components/common/SportStrip';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const CasinoLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <div className="bg-shell">
      <Header onMenuClick={() => setIsSidebarOpen(true)} />

      <div className="flex min-h-screen">
        <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(false)} />

        {/* `overflow-clip`, not `overflow-hidden`, so the sport strip can stick while scrolling. */}
        <div className="min-w-0 flex-1 overflow-clip">
          <StickySportStrip />
          <main className="min-w-0 overflow-hidden">
            <Outlet />
          </main>
        </div>
      </div>
      <BottomNav />
    </div>
  );
};

export default CasinoLayout;
